import React from 'react';
import { storesContext } from 'src/stores/index';

const useStores = () => React.useContext(storesContext);

export default useStores;
